import React, { Children, cloneElement, isValidElement, PureComponent } from 'react';
import RippleChild from './RippleChild';
import { getConfig, getPrefixCls } from '../configure';
import createChains from '../_util/createChains';
export default class Ripple extends PureComponent {
    render() {
        const { disabled, children, ...rest } = this.props;
        if (disabled || !children || !getConfig('ripple')) {
            if (children) {
                return Children.map(children, child => isValidElement(child) ? cloneElement(child, createChains(rest, child.props)) : child);
            }
            return children;
        }
        return Children.map(children, (child) => this.rippleChild(child, rest));
    }
    rippleChild(child, rest) {
        const { prefixCls } = this.props;
        return React.createElement(RippleChild, Object.assign({ prefixCls: getPrefixCls('ripple', prefixCls) }, rest), child);
    }
}
Ripple.displayName = 'Ripple';
